@if (images.length > 0) {
<div class="carousel-container" (click)="closeOnBackground($event)">
  <div class="carousel">
    <span class="close" (click)="closeCarousel()">×</span>

    @if (images.length > 1) {
    <button class="prev" (click)="prevImage()" [disabled]="currentIndex === 0">
      &#10094;
    </button>
    }

    <div class="carousel-track" [style.transform]="translateValue">
      @for (image of images; track $index) {
      <img [src]="image" alt="Selected Image" class="carousel-image" />
      }
    </div>

    @if (images.length > 1) {
    <button
      class="next"
      (click)="nextImage()"
      [disabled]="currentIndex === images.length - 1"
    >
      &#10095;
    </button>
    }
  </div>

  <div class="carousel-thumbnails">
    @for (image of images; track $index) {
    <img
      [src]="image"
      alt="Thumbnail"
      [class.selected]="$index === currentIndex"
      (click)="currentIndex = $index"
      class="thumbnail-image"
    />
    }
  </div>
</div>

}
